import { Stack } from "@chakra-ui/react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { withSession, WithSessionProps } from "ui-classic-common-library";

import { AppLayout } from "./components/AppLayout";
import CallAlertsAuxWindowWrap from "./components/CallAlertsAuxWindow/CallAlertsAuxWindowWrap";
import SubNav from "./components/SubNav";
import { PermissionsProvider } from "./contexts/permissions";
import CallsAlerts from "./pages/CallsAlertsPage";
import CreateCallPage from "./pages/CreateCallPage";
import ExportPage from "./pages/ExportPage";
import LoginPage from "./pages/LoginPage";
import MarginAccountDetailsPage from "./pages/MarginAccountDetailsPage";
import { AppRoutes } from "./routes";

interface AppProps extends WithSessionProps {
  hasSession: boolean;
}

function App({ hasSession, isLoadingSession }: AppProps) {
  return (
    <>
      {hasSession ? (
        <PermissionsProvider>
          <AppLayout
            appTitle="Margin Processing"
            isFixedHeader
            subNav={<SubNav />}
          >
            <Stack spacing={0} height="100%">
              <Routes>
                <Route path={"/"} element={<Outlet />}>
                  <Route
                    index
                    element={<Navigate to={AppRoutes.CallsAlerts} replace />}
                  />
                  <Route
                    path={AppRoutes.CallsAlerts}
                    element={<CallsAlerts />}
                  />
                  <Route
                    path={AppRoutes.MarginAccountDetails}
                    element={<MarginAccountDetailsPage />}
                  />
                  <Route
                    path={`/${AppRoutes.MarginAccountDetails}/:accountId/:tab?`}
                    element={<MarginAccountDetailsPage />}
                  />
                  <Route path={AppRoutes.Export} element={<ExportPage />} />
                  <Route
                    path={AppRoutes.CreateCall}
                    element={<CreateCallPage />}
                  />
                </Route>
                <Route path={AppRoutes.AuxWindow} element={<Outlet />}>
                  <Route
                    path={`${AppRoutes.EventDetails}/:eventId`}
                    element={<CallAlertsAuxWindowWrap />}
                  />
                </Route>
              </Routes>
            </Stack>
          </AppLayout>
        </PermissionsProvider>
      ) : (
        <LoginPage isLoadingSession={isLoadingSession} />
      )}
    </>
  );
}

export default withSession(App);
